import { convertFromHTML } from "draft-convert"

export const isEditorTextEmpty = (value: string) =>
  convertFromHTML(value).getPlainText("").trim().length === 0

export default null
